module.exports = __webpack_public_path__ + "img/arrow_right_color.81b78cc6.svg";